/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import styles from '../../assessmentPage/Questionnaire/GeneralInfo.module.scss';
import cn from 'classnames';
export interface Agent {
    firstname: string;
    lastname: string;
    middlename: string;
    role: string;
    email: string;
}

export const initAgent: Agent = {
    firstname: '',
    lastname: '',
    middlename: '',
    role: '',
    email: '',
};
export default function AdditionalConsultantsInfo() {
    const tableName = 'ImmigrationProfessional';

    const [agents, setAgents] = useState<Agent[]>([initAgent]);

    useEffect(() => {
        api.tableInput.newFetchCandidateInput(setAgents, tableName);
    }, []);

    return (
        <>
            <div>
                {agents?.map((item: any, index: number) => (
                    <span key={index}>
                        <h4 className={styles.title}>Consultant N{index + 1}</h4>
                        <div
                            className={`grid grid-cols-2  gap-x-5  ${cn(
                                styles.box,
                                styles.fullWidth
                            )}`}
                        >
                            <h4>Name</h4>
                            <h4>Role</h4>
                            <p className={styles.value}>
                                {item?.firstname} {item?.middlename} {item?.lastname}
                            </p>
                            <p className={styles.value}> {item?.role}</p>
                            <h4>Email</h4>
                            <h4 aria-hidden="true"></h4>
                            <p className={styles.value}> {item?.email}</p>
                        </div>
                    </span>
                ))}
            </div>
        </>
    );
}
